import Vue from 'vue'
import * as types from './mutation-types'

export default {
  [types.SET_STORE] (state, store) {
    Vue.set(state, 'store', store)
  },
  [types.SET_SOCKET_ID] (state, id) {
    state.socketId = id
  },
  [types.SET_CONNECTION_LOG] (state, { ms, socketId }) {
    state.connectionLog = socketId.substring(0, 5) + ' ' + ms + ' ' + new Date().toString().substring(0, 24)
  },
  [types.SET_SETTINGS] (state, settings) {
    Vue.set(state, 'settings', settings)
  },
  [types.SET_FONT_SIZE] (state, fontSize) {
    state.settings.fontSize = fontSize
  },
  [types.SET_MARGIN] (state, margin) {
    state.settings.margin = margin
  },
  [types.SET_TABLE_NUMBERS] (state, tableNumbers) {
    Vue.set(state, 'tableNumbers', tableNumbers)
  },
  [types.SET_TABLE_NUMBER_DIRTY] (state, dirty) {
    state.isTableNumberDirty = dirty
  },
  [types.SET_PRE_ORDER_RING] (state, ring) {
    state.settings.preOrderRing = ring
  },
  [types.SET_NEW_ORDER_RING] (state, ring) {
    state.settings.newOrderRing = ring
  },
  [types.SET_CURRENT_MINUTE] (state, minute) {
    state.currentMinute = minute
  },
  [types.SET_FULLSCREEN] (state, fullscreen) {
    state.fullscreen = fullscreen
  },
  [types.SET_NOTIFICATION] (state, notification) {
    Vue.set(state, 'notification', notification)
  },
  [types.SHOW_VERSION_DIALOG] (state) {
    state.showVersionDialog = true
  },
  [types.SHOW_WELCOME_DIALOG] (state) {
    state.showWelcomeDialog = true
  },
  [types.SHOW_HASVERSION_DIALOG] (state, version) {
    state.showNewVersionDialog = version
  }
}
